var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 10080 5040",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0V1.5H7V3H6zM6,0H3V3.5H0V3z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Star7",
    d: "M0,-360 69.421398,-144.155019 281.459334,-224.456329 155.988466,-35.603349 350.974048,80.107536 125.093037,99.758368 156.198146,324.348792 0,160 -156.198146,324.348792 -125.093037,99.758368 -350.974048,80.107536 -155.988466,-35.603349 -281.459334,-224.456329 -69.421398,-144.155019z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Star5",
    d: "M0,-210 54.859957,-75.508253 199.721868,-64.893569 88.765275,28.841586 123.434903,169.893569 0,93.333333 -123.434903,169.893569 -88.765275,28.841586 -199.721868,-64.893569 -54.859957,-75.508253z"
  }), /*#__PURE__*/React.createElement("use", {
    id: "Cstar",
    xlinkHref: "#Star7",
    transform: "scale(2.1)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(840)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 6,
    fill: "#00008b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 6,3M6,0 0,3",
    stroke: "#fff",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 6,3M6,0 0,3",
    stroke: "#f00",
    strokeWidth: 0.4,
    clipPath: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,0V3.5M0,1.5H7",
    stroke: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,0V3.5M0,1.5H7",
    stroke: "#f00",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,3H6V0H8V4H0z",
    fill: "#00008b"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    id: "Comwlth",
    xlinkHref: "#Cstar",
    x: 2520,
    y: 3780
  }), /*#__PURE__*/React.createElement("use", {
    id: "\u03B1Crucis",
    xlinkHref: "#Star7",
    x: 7560,
    y: 4200
  }), /*#__PURE__*/React.createElement("use", {
    id: "\u03B2Crucis",
    xlinkHref: "#Star7",
    x: 6300,
    y: 2205
  }), /*#__PURE__*/React.createElement("use", {
    id: "\u03B3Crucis",
    xlinkHref: "#Star7",
    x: 7560,
    y: 840
  }), /*#__PURE__*/React.createElement("use", {
    id: "\u03B4Crucis",
    xlinkHref: "#Star7",
    x: 8680,
    y: 1869
  }), /*#__PURE__*/React.createElement("use", {
    id: "\u03B5Crucis",
    xlinkHref: "#Star5",
    x: 8064,
    y: 2730
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHm);
export default __webpack_public_path__ + "static/media/hm.a9157abccd81a6a9b9e178ac9fb1344e.svg";
export { ForwardRef as ReactComponent };